module.exports = __webpack_public_path__ + "static/img/reportTriage.29a544a7.png";